import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ElementRef, Injectable, Injector, Renderer2} from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppUtil } from "src/app/core/utils/utils";
import { AuthService } from "../auth/auth.service";
import { SERVICE_GLOBAL } from "src/app/shared/constants/services.global";
import { environment } from 'src/environments/environment';
import { config } from "src/assets/config/config";
import { Country } from 'src/app/shared/country.type';

declare let showIntercept: Function;


@Injectable({
  providedIn: "root"
})
export class CommonService {
  public serviceGlobal: any;
  isNonSso = false;
  isInternal = false;
  appendUrl:string;
  private defaultLang: string;
  public environmentData: any;
  public countryId: any;

  constructor(private http: HttpClient, private authService: AuthService, private injector: Injector) { 
    this.serviceGlobal = this.injector.get(SERVICE_GLOBAL);
  }

  public getEnvironmentData() {
    let country: Country | null = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
     this.environmentData = environment[country];
     return this.environmentData;
  }

   public loadCountryData() {
        // Assign the imported JSON data to a variable
        let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
        return config[country];
    }
    translateStaticText(key: string, staticText: { [key: string]: string }): void {

    }
  /**
 * @description Method to get string data from session
 */
  public getStringFromSession (key: string): string {
    const item = AppUtil.getFromSession(key);
    const itemString = typeof item == "string"
      ? item
      : JSON.stringify(item);

    return itemString;
  }

  /**
  * @description Method to set Non SSO login flow true/false
  */
  public setNonSso (value: boolean): void {
    this.isNonSso = value;
  }

  /**
  * @description Method to get Non SSO login flow true/false
  */
  public getNonSso (): boolean {
    return this.isNonSso;
  }

  /**
  * @description Method to get whether logged In User is internal user or external user
  */
  public isInternalUser (): boolean {
    let returnValue = false;
    const countryId = sessionStorage.getItem("country_id");
    const userItem = AppUtil.getFromLocal(countryId+"_user");
    const user = typeof userItem == "string"
      ? JSON.parse(userItem)
      : {};
    const email = user["emailID"] || "";
    if (AppUtil.isStringInString(email, "@dnb.com")) {
      returnValue = true;
    }
    return returnValue;
  }

  /**
* Method to get appended url with userdata
* @param url redirection url
* @param userData user data
*/
  public getAppendedUrl (url: string, userData: any): string {
    this.appendUrl = "";
    this.appendUrl =
      "&email=" + userData["emailID"] +
      "&fname=" + userData["firstName"] +
      "&lname=" + userData["lastName"];
    return url + this.appendUrl;
  }

  setDefaultCountry(value: string): void {
    this.defaultLang = value
  }

  getDefaultCountry(): string {
    return this.defaultLang
  }

  getCountryId(): string {
    this.countryId = sessionStorage.getItem('country_id');
    return this.countryId
  }

  private languageSubject = new BehaviorSubject<string>(this.getInitialLanguage());
  language$ = this.languageSubject.asObservable();
  
  setLanguage(lang: string): void {
    sessionStorage.setItem('selectedLanguage', lang);
    this.languageSubject.next(lang);
  }

  public getLanguage(): any {
    return sessionStorage.getItem('selectedLanguage');
  }
  
  private getInitialLanguage(): any {
    return sessionStorage.getItem('selectedLanguage');
  }

  /**
  * @description Method to initialise qualtrics
  */
  public initQualtrics (): void {
   let config = this.loadCountryData()
   if(config?.qualtricsPageFeedback || config?.qualtricsArticleFeedback)
    showIntercept();
  }

  /**
  * @description Method to send customer gauge feedback
  */
  public sendRecord(data: any) {
      return this.http.put(this.serviceGlobal.CUSTOMER_GAUGE, data);
    }


    getSessionId(): string {
      let sessionId = sessionStorage.getItem("sessionId");
      if (!sessionId) {
        sessionId = `FS_${Math.random().toString(36).substr(2, 16)}`;
        sessionStorage.setItem("sessionId", sessionId);
      }
      return sessionId;
    }
  
  
    getSiteHistory(): string {
      let siteHistory = JSON.parse(sessionStorage.getItem("siteHistory") || "[]");
      const currentPage = `${window.location.href}~${Date.now()}`;
  
      siteHistory.push(currentPage);
      if (siteHistory.length > 5) siteHistory.shift(); 
      sessionStorage.setItem("visitedPageCount", siteHistory.length.toString());
  
      sessionStorage.setItem("siteHistory", JSON.stringify(siteHistory));
      return siteHistory.join("|");
    }
  
  
    getVisitedPageCount(): number {
      return JSON.parse(sessionStorage.getItem("siteHistory") || "[]").length;
    }
  
    getDeviceType(): string {
      if (navigator.userAgent.match(/mobile/i)) return "Mobile";
      if (navigator.userAgent.match(/tablet/i)) return "Tablet";
      return "Desktop";
    }
  
   getBrowserName(): string {
    const userAgent = navigator.userAgent;
  
    if (userAgent.indexOf("Edg") !== -1) return "Edge";
    if (userAgent.indexOf("Chrome") !== -1) return "Chrome";
    if (userAgent.indexOf("Firefox") !== -1) return "Firefox";
    if (userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1) return "Safari"; 
    if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident") !== -1) return "Internet Explorer";
  
    return "Other";
  }
  
    getTabIdFromUrl(): string {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("TAB_ID") || "N/A";
    }
  
    storeDeviceAndBrowserInfo() {
      const deviceType = this.getDeviceType();
      const browserName = this.getBrowserName();
    
      sessionStorage.setItem("deviceType", deviceType);
      sessionStorage.setItem("browserName", browserName);
    }
    
    getStoredDeviceType(): string {
      return sessionStorage.getItem("deviceType") || "Unknown";
    }
    
    getStoredBrowserName(): string {
      return sessionStorage.getItem("browserName") || "Unknown";
    }  
    
    public adjustDropdownPositions(el: ElementRef<any>, renderer: Renderer2) {
      const tabItems = el.nativeElement.querySelectorAll('#dynamicTabs li.nav-item');
      const containerWidth = el.nativeElement.offsetWidth;
      let accumulatedWidth = 0;
    
      tabItems.forEach((item: any, index: number) => {
        if (index > 0) {
          const previousItem = tabItems[index - 1];
          accumulatedWidth += previousItem.offsetWidth;
        }
    
        const tabId = item.querySelector('.nav-link').id.replace('-link', '');
        const dropdown = el.nativeElement.querySelector(`tab#${tabId} .dropdown`);
    
        if (dropdown) {
          const dropdownWidth = dropdown.offsetWidth;
          let leftPosition = accumulatedWidth;
    
          // Adjust if dropdown goes beyond container width
          if (leftPosition + dropdownWidth > containerWidth) {
            leftPosition = containerWidth - dropdownWidth;
            if (leftPosition < 0) leftPosition = 0; // Prevent negative positioning
          }
    
          renderer.setStyle(dropdown, 'left', `${leftPosition}px`);
        }
      });
    }
    
  }
